// Assets
import heroImage from '../../assets/img/hero/mushroom-pot-pie-hero.jpg';
import thumbnail from '../../assets/img/recipes/mushroom-pot-pie-thumb.jpg';

export default {
  hasTransparentNav: false,
  hasRebateCallout: true,
  metadata: {
    title: 'Mushroom Pot Pie by Chef Justin Thompson',
    description:
      'Chef Justin Thompson cooks two versions of this Mushroom Pot Pie recipe - one gets a reverse-sear start in the oven and both steaks get seared in a skillet before being basted in a brown-butter bath.',
    type: 'video.episode'
  },
  active: true,
  title: 'Mushroom Pot Pie',
  hero: {
    image: heroImage,
    video: '',
    title: '',
    cta: '',
    link: ''
  },
  episode: 'S1:E4',
  episodeLong: 'Season One Episode Four',
  className: 'episode-detail',
  thumbnail,
  content:
    'Who needs a grill when you can recreate Chef Justin Thompson’s ribeye at home on the range? One ribeye gets a reverse-sear start in the oven (totally worth the time) and both steaks get seared in a skillet before being basted in a brown-butter bath. Elevate your reverse-seared steak even more with a delicious broccolini pesto and festive veggie ribbons.',
  excerpt:
    'Chef Zach Hutton is all about using farm-fresh ingredients and showcasing local artisans, especially in this delicious pot pie. ',
  videoIds: ['Y1TqOwbpbEM'],
  playlistId: 'PL6bvPOjDXPzijS0wUPlVnGauAG99P2Ojn',
  url: '/episodes/mushroom-pot-pie',
  recipe: 'mushroomPotPie',
  chef: 'justinThompson',
  season: 1
};
